import type { FaireProductEntity } from "../../entity_types/product";

export const p_2tygnrvq7a: FaireProductEntity = {
  token: "p_2tygnrvq7a",
  type: "product",
  name: "Glass & Crystal Cross Charm - CS",
  brandToken: "b_nex9pcmkzj",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/1e14991dd7e8467c6a317cdbb176a1dc0f05f233ca625e0f8feab7b5216329af.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4251c41bfc7ade0e0a32fc160a6b323fb2fc7aad950775e0099b1fbc631bde06.jpeg",
    "https://cdn.faire.com/fastly/500a1eca02c32d961f8e26e955896f77032cf362f8b9975b6cee1f0e479e0c15.jpeg",
    "https://cdn.faire.com/fastly/f6be633cd839206df15265581994ad31cb487cdd032e5edc2247b7d6a30b56fb.jpeg",
  ],
  priceDollars: 12.69,
  description:
    "\nMaterial: Copper,Glass\n\nSize :77mm*105mm\n\nProcess: Retro\n\nSurface : High Polish\n\n★Made of high quality material, Nickel-free / Lead-free, Harmless to Human Body.\n\n★Perfect jewelry gifts                                                                            ",
  tags: [],
  msrpDollars: 25.37,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:36.765Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
